export default (tracker) => ({
  async opened(data) {
    await tracker.track('Upsell Selector Opened', data)
  },

  async closed(data) {
    await tracker.track('Upsell Selector Closed', data)
  },

  async confirmed(data) {
    await tracker.track('Upsell Selector Confirmed', data)
  },

  async removed(data) {
    await tracker.track('Upsell Removed', data)
  },

  async selectedUpsell(upsellCustomisedProduct) {
    if (!upsellCustomisedProduct) return

    await tracker.track('Selected Upsell', {
      baseSKU: upsellCustomisedProduct.baseSKU,
      sku: upsellCustomisedProduct.sku,
      price: upsellCustomisedProduct.price,
      compareAtPrice: upsellCustomisedProduct.compareAtPrice,
      lensTech: upsellCustomisedProduct.lensTech || '',
    })
  },

  async addUpsellToCart(upsellCustomisedProduct) {
    if (!upsellCustomisedProduct) return

    await tracker.track('Added Upsell to Cart', {
      baseSKU: upsellCustomisedProduct.baseSKU || upsellCustomisedProduct.product.baseSKU,
      sku: upsellCustomisedProduct.sku || upsellCustomisedProduct.product.sku,
      price: upsellCustomisedProduct.price,
      compareAtPrice: upsellCustomisedProduct.compareAtPrice,
      lensTech: upsellCustomisedProduct.lensTech || upsellCustomisedProduct.product.lensTech || '',
    })
  },
})
